import React, { useState } from 'react';
import WeighingProcessModal, { WeighingProcess } from './modals/WeighingProcessModal';

interface HeaderTabsProps {
  onNewWeighing: (process: WeighingProcess) => void;
  disabled?: boolean;
  defaultProcess?: WeighingProcess;
}

const HeaderTabs: React.FC<HeaderTabsProps> = ({ 
  onNewWeighing, 
  disabled = false, 
  defaultProcess = 'standard' 
}) => {
  const [showProcessModal, setShowProcessModal] = useState(false);

  const handleNewWeighingClick = () => {
    if (!disabled) {
      setShowProcessModal(true);
    }
  };

  const handleProcessSelect = (process: WeighingProcess) => {
    onNewWeighing(process);
    setShowProcessModal(false);
  };

  const handleModalClose = () => {
    setShowProcessModal(false);
  };

  return (
    <>
      <div className="flex items-center space-x-4">
        <button
          onClick={handleNewWeighingClick}
          disabled={disabled}
          className={`px-6 py-3 rounded-lg font-medium transition-colors flex items-center ${
            disabled
              ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
              : 'bg-orange-600 hover:bg-orange-700 text-white shadow-md hover:shadow-lg transform hover:scale-105'
          }`}
        >
          <i className="fas fa-plus mr-2"></i>
          Nouvelle pesée
        </button>
      </div>

      <WeighingProcessModal
        isOpen={showProcessModal}
        onClose={handleModalClose}
        onSelectProcess={handleProcessSelect}
        defaultProcess={defaultProcess}
      />
    </>
  );
};

export default HeaderTabs;
